import { createSlice } from "@reduxjs/toolkit"

// http client
import client from "../../../lib/client"
import { clientBillableAccountsConsecutiveEstimationsUrl, dynamicUrl, clientBillableAccountsConsecutiveEstimationsCsvUrl } from "../../../lib/endpoints"
import { createFilterUrl } from "../../../functions/objectFunctions/createFilterUrl"
import { createRansackParams } from "../../../functions/objectFunctions/createRansackParams"

export const billableAccountsConsecutiveEstimationsSlice = createSlice({
    name: "billableAccountsConsecutiveEstimations",
    initialState: {
        billableAccounts: [],
        total: 0,
        pagination: { current: 1, pageSize: 10 },
        loading: false,
    },
    reducers: {
        setBillableAccounts: (state, action) => {
            state.billableAccounts = action.payload.billable_accounts
            state.total = action.payload.total
        },
        setPagination: (state, action) => {
            state.pagination = action.payload
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
    },
})

export const { setBillableAccounts, setPagination, setLoading } = billableAccountsConsecutiveEstimationsSlice.actions

export function fetchBillableAccounts(pagination, currentPath) {
    return async (dispatch, getState) => {
        dispatch(setLoading(true))

        // This route may be nested so we have to use a dynamic route
        // /divisions VS /clients/client_id/divisions
        client.get(`${dynamicUrl(currentPath)}?page=${pagination.current}&per=${pagination.pageSize}`).then((response) => {
            dispatch(setPagination(pagination))
            dispatch(setBillableAccounts(response.data))
            dispatch(setLoading(false))
        })
    }
}

export function filterBillableAccounts(query) {
    /// create the filter URL string
    let filterUrl = createFilterUrl(query, clientBillableAccountsConsecutiveEstimationsUrl(query.clientId), "")

    return async (dispatch) => {
        dispatch(setLoading(true))
        client
            .get(filterUrl)
            .then((response) => {
                dispatch(setPagination(query.pagination))
                dispatch(setBillableAccounts(response.data))
                dispatch(setLoading(false))
            })
            .catch((error) => {
                console.warn(error)
            })
            .finally(() => {
                dispatch(setLoading(false))
            })
    }
}

export function generateCsv(clientId, filters) {
    return async (dispatch, getState) => {
        client.get(`${clientBillableAccountsConsecutiveEstimationsCsvUrl(clientId)}${createRansackParams(filters)}connection_id=${getState().app.uid}`)
    }
}

export const selectBillableAccounts = (state) => state.billableAccountsConsecutiveEstimations.billableAccounts
export const selectTotal = (state) => state.billableAccountsConsecutiveEstimations.total
export const selectPagination = (state) => state.billableAccountsConsecutiveEstimations.pagination
export const selectLoading = (state) => state.billableAccountsConsecutiveEstimations.loading

export default billableAccountsConsecutiveEstimationsSlice.reducer
